/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext, useEffect } from "react"
import { Fieldset } from "primereact/fieldset"
import PropTypes from "prop-types"
import { Toast } from "primereact/toast"
import { Toolbar } from "primereact/toolbar"
import CustomToolBar from "../../../ToolBar/customToolbar"
import {
  confirmationRefused,
  satisfactionTypes,
} from "../../../types/dropDownTypes"
import { errorMessages } from "../../../types/messages"
import {
  existsErrors,
  getAdditionalQuestions,
  showMessage,
  showQuestion,
  validateQuestions,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
  prevForm,
  nextForm,
} from "../../../utils/utils"
import SocialRow from "./SocialRow"
import { GpraContext } from "../../../../../context/gpraContext"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import {
  INTERVIEW_SECTIONS,
  INTERVIEW_TYPES,
} from "../../../types/interviewTypes"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"
import { UserContext } from "../../../../../context/userContext"

const Social = (props) => {
  const { showToolBar, disabled } = props
  const {
    handleSubmitPut,
    interview,
    handleLoadPrev,
    handleLoadNext,
    handleSectionsCompleted,
    sectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    sections,
    activeIndex,
    administrativeInterview,
    interviewType,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [social, setSocial] = useState(interview[INTERVIEW_SECTIONS.SOCIAL])
  const [validationErrors, setValidationErrors] = useState({})
  const [mixedQuestions, setMixedQuestions] = useState([])
  const toast = useRef(null)

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) =>
            q.section === INTERVIEW_SECTIONS.SOCIAL &&
            !q.field.endsWith("section")
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.SOCIAL
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  const saveData = (setNextForm, previousForm, setNavigationItem) => {
    updateInterviewValues(INTERVIEW_SECTIONS.SOCIAL, social)
    if (previousForm) {
      handleLoadPrev(true)
      setNextForm(prevForm(sections, activeIndex, administrativeInterview))
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_SOCIAL_DATA, {
          GpraG1: social?.gpra_g_1,
          GpraG1Num: social?.gpra_g_1_num,
          GpraG2: social?.gpra_g_2,
          GpraG3: social?.gpra_g_3,
          GpraG4: social?.gpra_g_4,
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraGId: social?.gpra_g_id,
          Additional: getAdditionalQuestions(social),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              updateInterviewValues(INTERVIEW_SECTIONS.SOCIAL, {
                ...social,
                gpra_g_id: response.data.gpraGId,
              })
              handleLoadNext(false)
              setNextForm(
                nextForm(
                  sections,
                  activeIndex,
                  interviewType !== INTERVIEW_TYPES.INTAKE
                    ? administrativeInterview
                    : true
                )
              )
              setNavigationItem()
              handleSectionsCompleted({
                ...sectionsCompleted,
                ...{ social: true },
              })
            }
          })
          .catch(() => {
            handleLoadNext(false)
            showMessage(false, errorMessages.genericError, toast)
          })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }

  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }

  const validForm = () => {
    const errors = {}
    if (!social?.gpra_g_1 && showQuestion(questions, "gpra_g_1")) {
      errors.gpra_g_1 = errorMessages.requiredMessage
    } else if (
      social?.gpra_g_1 === "Yes" &&
      showQuestion(questions, "gpra_g_1")
    ) {
      if (social?.gpra_g_1_num < 1 && showQuestion(questions, "gpra_g_1")) {
        errors.gpra_g_1_num = errorMessages.number
      }
    }
    if (!social?.gpra_g_2 && showQuestion(questions, "gpra_g_2")) {
      errors.gpra_g_2 = errorMessages.requiredMessage
    }

    if (!social?.gpra_g_3 && showQuestion(questions, "gpra_g_3")) {
      errors.gpra_g_3 = errorMessages.requiredMessage
    }

    if (!social?.gpra_g_4 && showQuestion(questions, "gpra_g_4")) {
      errors.gpra_g_4 = errorMessages.requiredMessage
    }

    setValidationErrors(
      validateQuestions(
        social,
        INTERVIEW_SECTIONS.SOCIAL,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }

  const renderDefaultMain = (question) => {
    if (question.field === "gpra_g_1") {
      return (
        <div className={gpraStyles.formRow}>
          <SocialRow
            legend={`${question.number}. In the past 30 days, did you attend any voluntary mutual support groups 
        for recovery? In other words, did you participate in a non-professional, peer-operated 
        organization that assists individuals who have addiction-related problems such as: 
        Alcoholics Anonymous, Narcotics Anonymous, Secular Organization for Sobriety, Women for 
        Sobriety, religious/faith-affiliated recovery mutual support groups, etc.? Attendance 
        could have been in person or virtual. [If yes, please specify how many times in the past 30 days]`}
            drop={social?.gpra_g_1}
            setDrop={"gpra_g_1"}
            num={social?.gpra_g_1_num}
            setNum={"gpra_g_1_num"}
            options={confirmationRefused}
            removeError={removeError}
            numError={validationErrors.gpra_g_1_num}
            numErrorType="gpra_g_1_num"
            dropError={validationErrors.gpra_g_1}
            dropErrorType="gpra_g_1"
            summaryDisabled={disabled}
            showNumber={social?.gpra_g_1 === "Yes"}
            entity={social}
            setEntity={setSocial}
            defaultZero={question.defaultZero}
            required
          />
        </div>
      )
    }
    if (question.field === "gpra_g_2") {
      return (
        <div className={gpraStyles.formRow}>
          <SocialRow
            legend={`${question.number}. In the past 30 days, did you have interaction with family and/or 
        friends that are supportive of your recovery?`}
            drop={social?.gpra_g_2}
            setDrop={"gpra_g_2"}
            options={confirmationRefused}
            removeError={removeError}
            dropError={validationErrors.gpra_g_2}
            dropErrorType="gpra_g_2"
            summaryDisabled={disabled}
            entity={social}
            setEntity={setSocial}
            defaultZero={question.defaultZero}
            required
          />
        </div>
      )
    }
    if (question.field === "gpra_g_3") {
      return (
        <div className={gpraStyles.formRow}>
          <SocialRow
            legend={`${question.number}. How satisfied are you with your personal relationships?`}
            drop={social?.gpra_g_3}
            setDrop={"gpra_g_3"}
            options={satisfactionTypes}
            removeError={removeError}
            dropError={validationErrors.gpra_g_3}
            dropErrorType="gpra_g_3"
            summaryDisabled={disabled}
            entity={social}
            setEntity={setSocial}
            defaultZero={question.defaultZero}
            required
          />
        </div>
      )
    }
    if (question.field === "gpra_g_4") {
      return (
        <div className={gpraStyles.formRow}>
          <SocialRow
            legend={`${question.number}. In the past 30 days did you realize that you need to change those 
        social connections or places that negatively impact your recovery?`}
            drop={social?.gpra_g_4}
            setDrop={"gpra_g_4"}
            options={confirmationRefused}
            removeError={removeError}
            dropError={validationErrors.gpra_g_4}
            dropErrorType="gpra_g_4"
            summaryDisabled={disabled}
            entity={social}
            setEntity={setSocial}
            defaultZero={question.defaultZero}
            required
          />
        </div>
      )
    }
  }

  return (
    <div>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              prevForm={true}
              saveData={saveData}
              nextForm={true}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
      <Fieldset
        legend="G. SOCIAL CONNECTEDNESS"
        style={{ marginBottom: "1rem" }}
      >
        <div className={gpraStyles.grid}>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <AdditionalQuestionContainer
                    entity={social}
                    setEntity={setSocial}
                    errors={validationErrors}
                    section={INTERVIEW_SECTIONS.SOCIAL}
                    removeError={removeError}
                    disabled={disabled}
                    question={question.question}
                    number={question.number}
                    kind={question.kind}
                  />
                )
              } else {
                if (checkDisplayConditional(question, social)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={social}
                      setEntity={setSocial}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.SOCIAL}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
      {showToolBar && (
        <Toolbar
          className="mt-4"
          right={
            <CustomToolBar
              prevForm={true}
              saveData={saveData}
              nextForm={true}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
    </div>
  )
}

Social.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}

Social.defaultProps = {
  showToolBar: true,
  disabled: false,
}

export default Social
